import React, { Component } from 'react'
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { steetToProduct } from 'src-features/api/streetSnap';
import LoaderCover from 'src-features/commonUI/loadingCover';
import UIComponent from '../component'
class StreetSnap extends Component {
    state = {
        isLoading: true,
        hasError: false,
        data: {}
    }
    fetchData = async() => {
        this.setState({
            isLoading: true,
            hasError: false
        })
        let data = await steetToProduct(this.props.match.params);
        if (data.isError || data.ret !== 0) {
            this.setState({
                isLoading: false,
                hasError: true
            })
        } else {
            this.setState({
                isLoading: false,
                data: {...data.data}
            })
        }
    }
    componentDidMount() {
        this.fetchData();
    }
    render() {
        console.log(this.props.match.params)
        return (
            <div>
                {!this.state.isLoading && <UIComponent data={{data: this.state.data}} streetID={this.props.match.params.streetSnapId}/>}
                <LoaderCover loading={this.state.isLoading}/>
            </div>
        )
    }
}

export default StreetSnap


// WEBPACK FOOTER //
// ./src/features/streetSnap/streetInfluencer/container/streetSnap.js